import { appToast } from 'components/Basic/CustomToast';
import { deleteFile } from 'components/CustomMapSelect/api';
import { useMutation } from 'react-query';

export function useDeleteCustomMap(uuid: string,) {
	return useMutation({
		mutationKey: `delete-custom-map-${uuid}`,
		mutationFn: async (id: number) => {
			await deleteFile(id);
			return true;
		},
		onError: (e)=>{
			appToast.error(`${e}`);
		}
	});
}